import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import { useSearchContext } from '@/libraries/contexts/search-context';
import styles from './search-bar-brand-selector-ledge.module.scss';

export interface SearchBarBrandSelectorLedgeProps {
  /** The class name to apply */
  className?: string;
  /** Whether the component has the connection curves */
  hideConnectionCurve?: boolean;
  /** An event that is triggered on brand change */
  onChange?: (value: Content.Properties.Brand) => void;
}

const brands: {
  headline: string;
  icon: IconName;
  id: Content.Properties.Brand;
}[] = [
  {
    headline: 'Sol',
    icon: 'Sun',
    id: 'default',
  },
  {
    headline: 'Rejseklubben',
    icon: 'Luggage',
    id: 'rejseklubben',
  },
  // Removing safari as per request, but keeping the code for future use
  // {
  //   headline: 'Bravo Safari',
  //   icon: 'Safari',
  //   id: 'safari',
  // },
  {
    headline: 'Bravo Golf',
    icon: 'Golf',
    id: 'golf',
  },
];

const SearchBarBrandSelectorLedge = ({
  className,
  hideConnectionCurve = false,
  onChange,
}: SearchBarBrandSelectorLedgeProps) => {
  const { brand } = useSearchContext();

  return (
    <div
      className={classNames(styles.component, className, {
        [styles.hasConnectionCurve]: !hideConnectionCurve,
      })}
    >
      <div className={styles.wrapper}>
        {brands.map((item, itemIndex) => (
          <button
            key={itemIndex}
            aria-pressed={brand === item.id}
            className={classNames(styles.button, {
              [styles.isActive]: brand === item.id,
            })}
            onClick={() => onChange?.(item.id)}
            type="button"
            {...(brand === item.id && { 'data-brand': brand })}
          >
            <Icon name={item.icon} size={24} />

            <Typography className={styles.text} tagStyle="bodySmall">
              {item.headline}
            </Typography>
          </button>
        ))}
      </div>
    </div>
  );
};

SearchBarBrandSelectorLedge.displayName = 'SearchBarBrandSelectorLedge';

export default SearchBarBrandSelectorLedge;
